<div class="service-advice">
  <mat-icon class="service-advice__icon">info</mat-icon>
  <span class="service-advice__text">{{ 'MAINTENANCES.TABS.SERVICES.ADVICE' | translate }}</span>
</div>
<form
  name="form"
  fxLayout="column"
  autocomplete="off"
  class="field-dialog__content__scroll tab-services p-24"
  fusePerfectScrollbar
>
  <div class="field-outline-form">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="12px">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>{{ 'MAINTENANCES.TABS.SERVICES.SEARCH_PLACEHOLDER' | translate }}</mat-label>
        <mat-icon matPrefix color="primary">search</mat-icon>
        <input matInput [formControl]="searchInputValue" (keydown)="$event.stopImmediatePropagation()" />
      </mat-form-field>
    </div>
  </div>

  <div class="tab-services__body">
    <p class="field-dialog__content__scroll__title">
      {{ 'MAINTENANCES.TABS.SERVICES.PERFORMED_SERVICES' | translate }} ({{
        (services && services.totalCount) || 0
      }}/150)
    </p>

    <div class="tab-services__body__value">
      <h4 class="tab-services__body__value__not-highlighted">
        {{ 'MAINTENANCES.TABS.SERVICES.PRODUCTS_VALUE' | translate }}
      </h4>
      <h4 class="tab-services__body__value__highlighted">R${{ maintenance.productsTotalValue || 0 | numberFormat }}</h4>
      <h4 class="tab-services__body__value__highlighted--sign">+</h4>
      <h4 class="tab-services__body__value__not-highlighted">
        {{ 'MAINTENANCES.TABS.SERVICES.SERVICES_VALUE' | translate }}
      </h4>
      <h4 class="tab-services__body__value__highlighted">R${{ maintenance.servicesTotalValue || 0 | numberFormat }}</h4>
      <h4 class="tab-services__body__value__highlighted--sign">=</h4>
      <h4 class="tab-services__body__value__not-highlighted">
        {{ 'MAINTENANCES.TABS.SERVICES.TOTAL_VALUE' | translate }}
      </h4>
      <h4 class="tab-services__body__value__highlighted">R${{ maintenance.totalValue || 0 | numberFormat }}</h4>
    </div>

    <ng-container *ngIf="filteredServices?.items?.length && !loadingServices">
      <div class="tab-services__body__table">
        <table class="tab-services__body__table__content">
          <thead class="tab-services__body__table__content__header">
            <tr class="tab-services__body__table__content__header__row">
              <th (click)="orderByName()">
                <span>{{ 'MAINTENANCES.TABS.SERVICES.TABLE.NAME' | translate }}</span>
                <mat-icon [ngClass]="orderBy === 'name_asc' ? 'name-asc' : 'name-desc'"> keyboard_arrow_down </mat-icon>
              </th>
              <th>{{ 'MAINTENANCES.TABS.SERVICES.TABLE.QUANTITY' | translate }}</th>
              <th *ngIf="paymentsFeatureFlag">{{ 'MAINTENANCES.TABS.SERVICES.TABLE.VALUE_TYPE' | translate }}</th>
              <th class="tab-services__body__table__content__header__row__value">
                {{ 'MAINTENANCES.TABS.SERVICES.TABLE.UNIT_VALUE' | translate }}
              </th>
              <th class="tab-services__body__table__content__header__row__total-value">
                {{ 'MAINTENANCES.TABS.SERVICES.TABLE.TOTAL_VALUE' | translate }}
              </th>
            </tr>
          </thead>
          <tbody class="tab-services__body__table__content__items">
            <tr *ngFor="let service of filteredServices.items" class="tab-services__body__table__content__items__row">
              <td class="tab-services__body__table__content__items__row__cell--image-name">
                <div
                  *ngIf="!service.item.imageUrl"
                  class="tab-services__body__table__content__items__row__cell--image-name__default-image"
                >
                  <img src="assets/images/icons/mdi_office-building.svg" />
                </div>
                <div
                  *ngIf="service.item.imageUrl"
                  class="tab-services__body__table__content__items__row__cell--image-name__image"
                >
                  <img [src]="service.item.imageUrl" [alt]="service.item.name" />
                </div>
                <span>
                  {{ service.item.name }}
                </span>
              </td>
              <td>
                {{ paymentsFeatureFlag ? (service | convertByValueType: maintenance.company.id) : service.quantity }}
              </td>
              <td *ngIf="paymentsFeatureFlag">
                {{
                  'MAINTENANCES.TABS.SERVICES.TABLE.VALUE_TYPES.' + (service | getValueType: maintenance.company.id)
                    | translate
                }}
              </td>

              <td [matTooltip]="value.tooltip" *ngIf="service | getValueService: maintenance.company.id as value">
                {{ value.label }}
              </td>

              <td class="tab-services__body__table__content__items__row__cell--total-value">
                R${{ service.totalValue | numberFormat }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="tab-services__body__table__navigation">
          <div class="tab-services__body__table__navigation__text">
            <p class="tab-services__body__paginate__title">
              {{
                'MAINTENANCES.TABS.SERVICES.PAGINATION.TITLE'
                  | translate
                    : {
                        limit:
                          paginationOffset + paginationLimit <= filteredServices.totalCount
                            ? paginationOffset + paginationLimit
                            : filteredServices.totalCount,
                        offset: paginationOffset + 1,
                        totalCount: filteredServices.totalCount
                      }
              }}
            </p>
          </div>
          <button
            class="tab-services__body__table__navigation__button-previous"
            (click)="toPreviousPage()"
            [disabled]="!filteredServices.pageInfo.hasPreviousPage || loadingServices"
          >
            {{ 'MAINTENANCES.TABS.SERVICES.PAGINATION.PREVIOUS' | translate }}
          </button>
          <button
            class="tab-services__body__table__navigation__button-next"
            (click)="toNextPage()"
            [disabled]="!filteredServices.pageInfo.hasNextPage || loadingServices"
          >
            {{ 'MAINTENANCES.TABS.SERVICES.PAGINATION.NEXT' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="loadingServices">
      <div class="tab-services__body__loading">
        <mat-spinner color="primary" diameter="64"></mat-spinner>
        <span>{{ 'MAINTENANCES.TABS.SERVICES.LOADING' | translate }}</span>
      </div>
    </ng-container>
    <div
      *ngIf="(!filteredServices?.items?.length || !services?.items?.length) && !loadingServices"
      class="tab-services__body__not-found"
    >
      <img src="assets/images/icons/ic_search_none_24px.svg" />
      <span *ngIf="!filteredServices?.items?.length && services?.items?.length">
        {{ 'MAINTENANCES.TABS.SERVICES.NOT_FOUND' | translate }}
      </span>
      <span *ngIf="!services?.items?.length">
        {{ 'MAINTENANCES.TABS.SERVICES.LINKED_NOT_FOUND' | translate }}
      </span>
    </div>
  </div>
</form>
